/**
 * Searchbar Module
 * @dependencies gsap > 3.0
 */

import { gsap } from 'gsap'
import { createFocusTrap } from 'focus-trap'

window.addEventListener('load', () => {
  // DOM Elements
  const searchModule = document.querySelector('.search-module')
  if (!searchModule) {
    return
  }

  const searchDisplay = document.querySelector('.js-search-module-display')
  const searchToggle = searchModule.querySelectorAll('.js-search-module-open, .js-search-module-close, .js-search-module-backdrop')
  const searchBg = searchModule.querySelector('.js-search-module-bg')
  const searchBackdrop = searchModule.querySelector('.js-search-module-backdrop')
  const searchContent = searchModule.querySelector('.js-search-module-content')
  const searchClose = searchModule.querySelector('.js-search-module-close')
  const searchInput = searchModule.querySelector('input[type="search"]')
  const searchTrap = createFocusTrap(searchModule)
  let searchOpened = false

  const closeSearch = () => {
    // Closing Tween
    const tl = gsap.timeline()
    tl.to(searchBg, { duration: 0.5, scaleY: 0, ease: 'power3.out' }, 'start')
      .to(searchContent, { duration: 0.5, y: -80, autoAlpha: 0, ease: 'power3.out' }, 'start+=0')
      .to(searchBackdrop, { duration: 0.5, autoAlpha: 0 }, 'start+=0')
      .to(searchClose, { duration: 0.4, autoAlpha: 0, ease: 'power3.out' }, 'start+=0')
      .set(searchDisplay, { autoAlpha: 0 });
    searchOpened = false;
  }

  searchModule.addEventListener('keyup', (e) => {
    if (e.key !== 'Escape') {
      return
    }
    closeSearch()
  })

  // Events
  if (searchToggle.length) {
    searchToggle.forEach((el) => {
      el.addEventListener('click', (ev) => {
        ev.preventDefault()

        if (searchOpened) {
          closeSearch()
          searchTrap.deactivate()
        }
        else {
          // Opening Tween
          const tl = gsap.timeline({
            onComplete() {
            // When the opening is complete, toggle the focus on the inputsearchInput.focus();
              setTimeout(() => {
                searchInput.focus()
              }, 1)
            },
          })
          tl.set(searchDisplay, { autoAlpha: 1 }, 'start')
          tl.fromTo(searchBackdrop, { duration: 0.5, autoAlpha: 0 }, { autoAlpha: 1 }, 'start+=0')
          tl.fromTo(searchBg, { duration: 0.5, scaleY: 0, ease: 'power3.out' }, { scaleY: 1, ease: 'power3.out' }, 'start+=0')
          tl.fromTo(searchClose, { duration: 0.5, y: -80, autoAlpha: 0, ease: 'power3.out' }, { y: 0, autoAlpha: 1, ease: 'power3.out' }, 'start+=0.1')
          tl.fromTo(searchContent, { duration: 0.5, y: -80, autoAlpha: 0, ease: 'power3.out' }, { y: 0, autoAlpha: 1, ease: 'power3.out' }, 'start+=0.15')
          searchOpened = true
          searchTrap.activate()
        }
      })
    })
  }
})
